import { AutomationRuleActionsEnum } from 'src/editor/shared/types/automation-rules/actions-types'
import { useAutomationRules } from 'client/store'
import automationRulesSelectors from 'client/store/automationRules/automationRulesSelectors'
import { getDefaultActionValue } from 'src/editor/shared/settings/automation-rules-settings/utils/get-default-action-value'

export const useGetDefaultAction = () => {
  const maxActionId = useAutomationRules(
    automationRulesSelectors.getMaxAutomationActionId,
  )

  return (actionType: AutomationRuleActionsEnum) =>
    getDefaultActionValue(actionType, maxActionId)
}
